import React from "react";
import { components } from "react-select";
import { Flex } from "atoms";

export const IconOption = ({ ...props }) => {
  const { Option } = components;
  return (
    <Option {...props}>
      <Flex aI="center" jC="space-between">
        {/* <input type="checkbox" id="id" name="name" value={props.data.label} /> */}
        {props.data.label}
      </Flex>
    </Option>
  );
};
